export function switchDisplayView(switchContainerSelector: string): void {
  const buttonsContainer = document.querySelector<HTMLElement>(switchContainerSelector);
  if (!buttonsContainer)
    return;

  const displayContainerId = buttonsContainer.getAttribute('aria-controls');
  if (displayContainerId == null)
    return;

  const displayContainer = document.getElementById(displayContainerId);
  if (!displayContainer)
    return;

  const allButtons = buttonsContainer.querySelectorAll('button');

  function handleButton(this: HTMLElement): void {
    for (const btn of allButtons) {
      btn.setAttribute('aria-pressed', 'false');
    }
    this.setAttribute('aria-pressed', 'true');

    if (displayContainer) {
      if (this.getAttribute('data-cards-view') === 'list') {
        displayContainer.setAttribute('data-cards-view', 'list');
      }
      else {
        displayContainer.removeAttribute('data-cards-view');
      }
    }
  }

  for (const btn of allButtons) {
    btn.addEventListener('click', handleButton);
  }
}
